import { render, staticRenderFns } from "./refundManage.vue?vue&type=template&id=0082f0f4&scoped=true&"
import script from "./refundManage.vue?vue&type=script&lang=js&"
export * from "./refundManage.vue?vue&type=script&lang=js&"
import style0 from "./refundManage.vue?vue&type=style&index=0&id=0082f0f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0082f0f4",
  null
  
)

export default component.exports